module.exports = __webpack_public_path__ + "img/instalar_tejas_porcelanatos_pisos.0b99cb10.png";